<template>
    <div class="lineup">
        <div v-if="playerList && playerList.has_lineup != 0">
            <ItemList
                v-if="playerList.home_starter_list.length > 0 && playerList.home_formation "
                :playerList="playerList"
            />
            <div v-else class="linUpKong">
                <div class="box">
                    <div class="img">
                        <img src="../../assets/img/matchDetails/empty.png" alt="">
                    </div>
                    <div class="foters">
                        暂无阵容数据~
                    </div>
                </div>
            </div>
            <tableNav title="阵容介绍"/>
            <div class="foter">
                <div class="lin" v-if="playerList.home_starter_list.length > 0 || playerList.away_starter_list.length > 0">
                    <tableItem
                    :title="playerList.has_lineup == 2 ? '预测首发阵容':'首发阵容'"
                    type="home"
                    :team="playerList.home_team_info.team_name"
                    :data="playerList.home_starter_list"
                    />
                </div>
                <div class="lin">
                    <tableItem
                     :title="playerList.has_lineup == 2 ? '预测首发阵容':'首发阵容'"
                    type="away"
                    :team="playerList.away_team_info.team_name"
                    :data="playerList.away_starter_list"
                    />
                </div>
            </div>
            <div class="foter item2" v-if="playerList.home_substitute_list.length > 0 || playerList.away_substitute_list.length > 0">
                <div class="lin">
                    <tableItem
                     :title="playerList.has_lineup == 2 ? '预测替补阵容':'替补阵容'"
                    type="home"
                    :team="playerList.home_team_info.team_name"
                    :data="playerList.home_substitute_list"
                    />
                </div>
                <div class="lin">
                    <tableItem
                    :title="playerList.has_lineup == 2 ? '预测替补阵容':'替补阵容'"
                    type="away"
                    :team="playerList.away_team_info.team_name"
                    :data="playerList.away_substitute_list"
                    />
                </div>
            </div>
            <div class="foter item2" v-if="playerList.home_player_injury.length > 0 || playerList.away_player_injury.length > 0">
                <div class="lin">
                    <tableItem
                    title="伤停阵容"
                    type="home"
                    :team="playerList.home_team_info.team_name"
                    falg="shang"
                    :data="playerList.home_player_injury"
                    />
                </div>
                <div class="lin">
                    <tableItem
                    title="伤停阵容"
                    type="away"
                    :team="playerList.away_team_info.team_name"
                    falg="shang"
                    :data="playerList.away_player_injury"
                    />
                </div>
            </div>
        </div>
        <div v-else class="empty">
            <span><img src="../../assets/img/matchDetails/empty.png" alt=""></span>
            <span>暂无数据！</span> 
        </div>
    </div>
</template>

<script>
import ItemList from "../../components/match/lineup/ItemList.vue"
import tableItem from "../../components/match/lineup/tableItem.vue"
import tableNav from "../../components/match/common/table_nav.vue"
import { matchPlayerList } from "../../api/api"
export default {
    name: "lineup",
    props: ['match_id', 'status', 'tabs'],
    components:{
        ItemList,
        tableItem,
        tableNav
    },
    data () {
        return {
            playerList: null,
            time: null
        }
    },
    watch: {
        tabs: {
            handler (news) {
                if (news == 2) {
                     this.forFun()
                } else {
                    clearInterval(this.time)
                }
            },
            immediate: true
        },
        match_id () {
            this.forFun()
        }
    },
    methods: {
        forFun () {
            clearInterval(this.time)
            if (this.tabs != 2) return
            if (this.status == 2) {
                this.getPlayerList()
                this.time = setInterval (() => {
                    this.getPlayerList()
                },60000)
            } else {
                this.getPlayerList()
                clearInterval(this.time)
            }
        },
        async getPlayerList () {
            const params = {
                sport_id: 1,
                match_id: this.match_id
            }
            let params2 = {}
            if (this.status == 2) {
                params2.r = parseInt(new Date().getTime() / 1000) 
            }
            const res = await matchPlayerList(params,params2)
            if (res.code == 0) {
                this.playerList = res.data
            }
        }
    }
}
</script>

<style lang="less" scoped>
.lineup{
    // overflow: hidden;
	overflow: hidden auto;
    height: 100%;
    width: 940px;
    background: #fff !important;
    .linUpKong{
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        text-align: center;
        .img{
            display: flex;
            justify-content: center;
            img{
                width: 180px;
                height: 140px;
            }
        }
    }
    .empty{
        height: 600px;
        // box-shadow: 0px 0px 20px 0px rgba(21, 21, 21, 0.06);
        display: flex;
        flex-direction: column;
        justify-content: center;
        span{
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            text-align: center;
            &:first-child{
                padding-top:32px ;
                margin-bottom:10px ;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  width: 180px;
                 height: 140px;  
                }
                
            }
        }
    }
    .foter{
        margin-right: 20px;
        display: flex;
        // justify-content: space-between;
        // box-shadow: 0px 0px 20px 0px rgba(21, 21, 21, 0.06);
        background: #fff;
        // padding: 0 20px;
        // padding-bottom:20px ;
        .lin{
            width: 460px;
            &:first-child{
                margin-right: 9px;
            }
            // height: 444px;
        }
    }
    .item2{
        margin-top: 11px;
    }
}
</style>